export default __webpack_public_path__ + "static/KeywordResearch_01_03@2x-0d5871ff2c58fcfebc72fcf80cfaa870.png";